<template>
  <div>
    <table>
      <tr>
        <td>Номер договора</td>
        <td>Продукт</td>
        <td>Срок займа</td>
        <td>ПСК%</td>
        <td>Дата платежа по графику (с указанием дня недели)</td>
        <td>Сумма платежа по графику</td>
        <td>Срок просрочки</td>
        <td>Начисленные пени + % на ОД</td>
        <td>Общая текущая задолженность</td>
<!--        <td>Предв. сумма для лонгации</td>-->
<!--        <td>Предв. дата при лонгации</td>-->
      </tr>
      <tr>
        <td>{{leadTmp.DlCode}}</td>
        <td>{{leadTmp.type_prod}}</td>
        <td>{{leadTmp.period}}</td>
        <td>{{leadTmp.psk}}</td>
        <td>{{leadTmp.CurDate}}</td>
        <td>{{leadTmp.CurPay}}</td>
        <td>{{leadTmp.overdue}}</td>
        <td>{{leadTmp.Penny}}</td>
        <td>{{leadTmp.DebtAll}}</td>
<!--        <td>{{leadTmp.SumForRenewal}}</td>-->
<!--        <td>{{leadTmp.NewDateForRenewal}}</td>-->
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    name: "dealInfo",
    props:{
      leadTmp:{
        type:Object,
        default:{
          CurDate: "",
          CurPay: 0,
          NewDateForRenewal: "",
          Penny: 0,
          SumForRenewal: 0,
          isRenewalOk: 0,
          overdue: 0,
          period: 0,
          psk: 0,
          type_prod: "PDL",
          DlCode:0,
          DebtAll:0,
        }
      }
    }
  }
</script>

<style scoped>
  table {border-collapse: collapse}
  table > tr > td {border: 1px solid black}
</style>
